import ApiClient from "./ApiClient";
import qs from "query-string";

let organisationId = null;

const XeroClientFactory = () => {
  return () =>
    ApiClient({
      baseURL: `/api/xero/${organisationId ?? 0}`,
      paramsSerializer: ({ appParams, extra_params, ...params }) =>
        qs.stringify({
          query: JSON.stringify({
            ...params,
            extra_params,
          }),
          ...appParams,
        }),
    });
};

export const setOrganisationId = (id) => {
  organisationId = id;
};

const XeroClient = XeroClientFactory();

export default XeroClient;
